export default __webpack_public_path__ + "static/media/successSign.9ca85326.svg";